import moment from 'moment';

type DisplayDelimiter = '-' | '/';

const DISPLAY_PARSE_FORMATS = [moment.ISO_8601, 'YYYY-MM-DD', 'MM/DD/YYYY', 'MM-DD-YYYY'];

const formatDateWithDelimiter = (dateString: string | Date, delimiter: DisplayDelimiter, isUtc?: boolean): string => {
  const parsed =
    dateString instanceof Date
      ? isUtc
        ? moment.utc(dateString)
        : moment(dateString)
      : isUtc
        ? moment.utc(dateString, DISPLAY_PARSE_FORMATS, true)
        : moment(dateString, DISPLAY_PARSE_FORMATS, true);

  if (!parsed.isValid()) {
    return '';
  }

  const formatPattern = delimiter === '-' ? 'MM-DD-YYYY' : 'MM/DD/YYYY';
  return parsed.format(formatPattern);
};

export const formatDateForHyphenDisplay = (dateString?: string | Date | null, isUtc?: boolean): string => {
  if (!dateString) {
    return '';
  }

  return formatDateWithDelimiter(dateString, '-', isUtc);
};

export const formatDateForSlashDisplay = (dateString: string | Date | null, isUtc?: boolean): string => {
  if (!dateString) {
    return '';
  }

  return formatDateWithDelimiter(dateString, '/', isUtc);
};
